import { render, staticRenderFns } from "./WriteReviewDrawer.vue?vue&type=template&id=24801440&scoped=true&"
import script from "./WriteReviewDrawer.vue?vue&type=script&lang=ts&"
export * from "./WriteReviewDrawer.vue?vue&type=script&lang=ts&"
import style0 from "./WriteReviewDrawer.vue?vue&type=style&index=0&id=24801440&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24801440",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconsSpinner: require('/var/www/packages/theme/components/icons/spinner/Spinner.vue').default,AtomsInlineNotification: require('/var/www/packages/theme/components/atoms/InlineNotification.vue').default,AtomsRadioButton: require('/var/www/packages/theme/components/atoms/RadioComponent/RadioButton.vue').default,AtomsSelectableRatingStarsBar: require('/var/www/packages/theme/components/atoms/SelectableRatingStarsBar.vue').default,AtomsInputField: require('/var/www/packages/theme/components/atoms/InputField.vue').default,AtomsKETextArea: require('/var/www/packages/theme/components/atoms/KETextArea.vue').default,AtomsSocialContactButton: require('/var/www/packages/theme/components/atoms/SocialContactButton.vue').default,AtomsKEButton: require('/var/www/packages/theme/components/atoms/KEButton.vue').default,AtomsKEDrawer: require('/var/www/packages/theme/components/atoms/KEDrawer.vue').default})
